import { render, staticRenderFns } from "./benefitInfoCard.vue?vue&type=template&id=671679f1"
import script from "./benefitInfoCard.vue?vue&type=script&lang=js"
export * from "./benefitInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports